import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import '../../../assets/css/customer/venues/HotelSection.css';

const HotelSection = () => {
  // Hotels Data
  const hotelsData = [
    {
      id: 1,
      name: 'Silver Cloud Hotel',
      description: 'Feugiat pretium egestas enim blandit purus euismod. Feugiat magna aliquam lectus lectus eu amet. Eros, accumsan purus enim nascetur quam diam felis, fringilla varius.',
      bookingLink: '#'
    },
    {
      id: 2,
      name: 'Cedarbrook Lodge',
      description: 'Nec laoreet tristique orci viverra sed aliquam. Amet odio ornare fermentum amet adipiscing malesuada turpis diam augue. Eget enim ultrices etiam nibh at porta.',
      bookingLink: '#'
    },
    {
      id: 3,
      name: 'Hotel Genevieve',
      description: 'Cras rhoncus malesuada eget vitae eleifend. Sodales purus et aliquam diam, nascetur at habitant. A, vel, donec at commodo eu non ac interdum.',
      bookingLink: '#'
    }
  ];

  return (
    <section className="hotel-accommodations-section">
      <Container>
        {/* Section Header */}
        <Row className="justify-content-center mb-5">
          <Col xs={12} className="text-center">
            <p className="hotel-section-subtitle">
              Where to stay
            </p>
          </Col>
        </Row>

        {/* Hotels Grid */}
        <Row className="hotel-cards-row g-4">
          {hotelsData.map((hotel) => (
            <Col 
              xs={12} 
              md={6} 
              lg={4} 
              key={hotel.id}
            >
              <div className="hotel-card">
                {/* Hotel Name */}
                <h3 className="hotel-card-name">
                  {hotel.name}
                </h3>

                {/* Hotel Description */}
                <p className="hotel-card-description">
                  {hotel.description}
                </p>

                {/* Book Button */}
                <Button 
                  variant="outline-custom" 
                  className="hotel-book-btn"
                  href={hotel.bookingLink}
                >
                  Book Here
                </Button>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default HotelSection;